// extracted by mini-css-extract-plugin
module.exports = {"Main":"layout_Main__ECtal"};